// extracted by mini-css-extract-plugin
export default {"label":"Counter_label__xq+ig","counterContainer":"Counter_counterContainer__CKCvd","icon":"Counter_icon__mAKff","input":"Counter_input__kXbUc","button":"Counter_button__0NstM"};